import BasePolicy from '@/policies/BasePolicy.js';

export default class RubricBankPolicy extends BasePolicy {
    viewAny(user) {
        const permission = 'view all rubric banks';

        return user.hasPermissionTo(permission) || user.hasGroupPermissionTo(permission);
    }

    view(user, rubricBank) {
        const permission = 'view a rubric bank';

        if (user.hasGroupPermissionTo(permission)) {
            return user.isInAssetGroup(rubricBank);
        }

        return user.hasPermissionTo(permission);
    }

    create(user) {
        const permission = 'create a rubric bank';

        if (user.hasGroupPermissionTo(permission)) {
            return false;
        }

        return user.hasPermissionTo(permission);
    }

    update(user, rubricBank) {
        const permission = 'edit a rubric bank';

        if (user.hasGroupPermissionTo(permission)) {
            return user.isInAssetGroup(rubricBank);
        }

        return user.hasPermissionTo(permission);
    }

    delete(user) {
        const permission = 'delete a rubric bank';

        if (user.hasGroupPermissionTo(permission)) {
            return false;
        }

        return user.hasPermissionTo(permission);
    }
}
